import { NULL_TAG } from '@racemap/utilities/consts/events';
import classnames from 'classnames';
import type { ItemStyle } from 'react-tiny-virtual-list';
import { ALL_TAG } from 'src/lib/player/constants';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';

export type StarterGroupHeaderProps = {
  style: ItemStyle;
  tagKey: string;
  tagValue: string;
  isOpen: boolean;
  starterCount: number;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function StarterGroupHeader({
  style,
  tagKey,
  tagValue,
  isOpen,
  starterCount,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: StarterGroupHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header starter-list-group-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        {isOpen ? (
          <i className="fas fa-chevron-down" />
        ) : (
          <i className="fas fa-chevron-down fa-rotate-270" />
        )}
        &nbsp;
        <div className="starter-list-header-item-label">
          {tagKey === ALL_TAG ? (
            t('tags.all')
          ) : (
            <>
              {t(`tags.${tagKey}`, tagKey)}:&nbsp;
              {tagValue === NULL_TAG ? t('tags.none') : tagValue}
            </>
          )}
          &nbsp;<span className="starter-list-header-item-info">{starterCount}</span>
        </div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
